Profiling.Dashboard ||= {}

class Profiling.Dashboard.ResultRowDetails extends Backbone.View
  template: JST["backbone/templates/profiling/sessions/results_details"]
  className: 'sc-details'

  initialize: (@options = {}) ->
    @model = @options.model

  render: ->
    @$el.html(@template(@model))
    @
